import { Injectable, inject } from '@angular/core'
import { ICandidatePool } from '@employer/app/models/candidate-pool.model'
import { selectors } from '@employer/app/store/selectors'
import { environment } from '@employer/environments/environment'
import { IAlgoliaKeyPackage } from '@engineering11/types'
import { isNotNil } from '@engineering11/utility'
import { E11ErrorHandlerService } from '@engineering11/web-api-error'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { getBaseSuffix } from 'shared-lib'
import { CandidatePoolRepository } from './candidate-pool.repository'

@Injectable({ providedIn: 'root' })
export class CandidatePoolService {
  private errorHandler = inject(E11ErrorHandlerService)

  private restApiClient: RestApiClient = new RestApiClient({
    baseUrl: environment.services.candidatePool,
    token: this.store.select(selectors.getCurrentToken).pipe(filter(isNotNil)),
    baseSuffix: getBaseSuffix(environment, 'candidatePool'),
  })

  constructor(private store: Store, private repository: CandidatePoolRepository) {}

  getByCandidateId(id: string): Observable<ICandidatePool | undefined> {
    return this.repository.get(id)
  }

  getPoolSearchKey(): Observable<IAlgoliaKeyPackage> {
    return this.restApiClient.get<IAlgoliaKeyPackage>(`search-key/customer`).pipe(map(item => item.data))
  }
}
